import React, { useState, useEffect } from 'react'
import { useIntl, IntlContextConsumer, changeLocale } from 'gatsby-plugin-intl'
import { useCookies } from 'react-cookie'
import Logo from 'assets/svgs/logo.svg'
import * as S from './NavbarMobile.styles'

const languageCurrent = {
  en: 'navbar.mobile.english',
  pt: 'navbar.mobile.portuguese',
}

const NavbarMobile = () => {
  const { formatMessage, locale } = useIntl()
  const [, setCookie] = useCookies(['language'])
  const [isOpen, setIsOpen] = useState()
  const [showOptions, setShowOptions] = useState(false)

  const handleClose = () => {
    setIsOpen(false)
    setShowOptions(false)
  }

  const handleOpen = () => setIsOpen(true)

  useEffect(() => {
    setCookie('language', locale, {
      path: '/',
    })
  }, [])

  return (
    <>
      <S.Wrapper>
        <S.LogoWrapper href="#">
          <Logo src={Logo} aria-label="Vale" />
        </S.LogoWrapper>
        <S.OpenMenu2 isOpen={isOpen} onClick={handleOpen}>
          <span />
          <span />
          <span />
        </S.OpenMenu2>
      </S.Wrapper>
      <S.Menu isOpen={isOpen}>
        <S.LogoWrapper>
          <Logo src={Logo} aria-label="Vale" />
        </S.LogoWrapper>
        <S.CloseButton isOpen={isOpen} onClick={handleClose}>
          <span />
          <span />
        </S.CloseButton>
        <S.MenuNav isOpen={isOpen}>
          <S.MenuLink href="#about">
            <span onClick={handleClose}>
              {formatMessage({ id: 'navbar.meeting' })}
            </span>
          </S.MenuLink>
          <S.MenuLink href="#program">
            <span onClick={handleClose}>
              {formatMessage({ id: 'navbar.schedule' })}
            </span>
          </S.MenuLink>
          <S.MenuLink href="#projects">
            <span onClick={handleClose}>
              {formatMessage({ id: 'navbar.projects' })}
            </span>
          </S.MenuLink>
          <S.LanguageWrapper show={showOptions}>
            <S.MenuLink
              role="button"
              active={showOptions}
              onClick={() => setShowOptions(!showOptions)}
            >
              {formatMessage({ id: 'navbar.mobile.changeLanguage' })}
            </S.MenuLink>
            <IntlContextConsumer>
              {({ languages, language: currentLanguage }) =>
                languages.map((language) => (
                  <S.LanguageOption
                    key={language}
                    active={currentLanguage === language}
                    show={showOptions}
                    onClick={() => {
                      setCookie('language', language, {
                        path: '/',
                      })
                      changeLocale(language), setIsOpen(false)
                    }}
                  >
                    {formatMessage({ id: languageCurrent[language] })}
                  </S.LanguageOption>
                ))
              }
            </IntlContextConsumer>
          </S.LanguageWrapper>
        </S.MenuNav>
        <S.Space />
      </S.Menu>
    </>
  )
}

export default NavbarMobile
